<template>
  <nav>
    <div class="flex items-center justify-center">
      <button
        @click="$router.push('/')"
        class="text-lg text-[#f8f7f2] px-4 py-2 m-2 hover:bg-[#ffffff11] rounded"
      >
        Home
      </button>
      <button
        @click="$router.push('/sobre')"
        class="text-lg text-[#f8f7f2] px-4 py-2 m-2 hover:bg-[#ffffff11] rounded"
      >
        Sobre
      </button>
      <button
        @click="$router.push('/projetos')"
        class="text-lg text-[#f8f7f2] px-4 py-2 m-2 hover:bg-[#ffffff11] rounded"
      >
        Projetos
      </button>
    </div>
  </nav>
</template>

<script>
export default {};
</script>

<style>
</style>